import { initializeApp } from "firebase/app";
import {
	deleteToken,
	getMessaging,
	getToken,
	onMessage,
} from "firebase/messaging";
import { getFirestore } from "firebase/firestore";
import { getRemoteConfig } from "firebase/remote-config";

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

const messaging = getMessaging();

export const database = getFirestore(app);

export const remoteConfig = getRemoteConfig(app);

remoteConfig.settings = {
	minimumFetchIntervalMillis: 5000, // 5 seconds for testing only
	fetchTimeoutMillis: 5000, // 5 seconds for testing only
  };


// Getting the FCM token from user
export const requestForToken = () => {
	if (!process.env.REACT_APP_FIREBASE_API_KEY) return null;
	return getToken(messaging, {
		vapidKey: process.env.REACT_APP_VAPID_KEY || process.env.VAPID_KEY,
	})
		.then((currentToken) => {
			if (currentToken) {
				return currentToken;
			} else {
				console.info(
					"No registration token available. Request permission to generate one."
				);
			}
		})
		.catch((err) => {
			console.error("An error occurred while retrieving token. ", err);
		});
};

// Delete FCM token
export const deleteNotificationToken = () => {
	if (!process.env.REACT_APP_FIREBASE_API_KEY) return null;

	getToken(messaging)
		.then((token) => {
			deleteToken(messaging)
				.then(() => {
					console.info("Token Deleted");
				})
				.catch((err) => {
					console.error("Token Deletion Failed: ", err);
				});
		})
		.catch((err) => {
			console.error("Token Retrieve Failed: ", err);
		});
};

// Foreground Message Listener
export const onMessageListener = () =>
	new Promise((resolve) => {
		onMessage(messaging, (payload) => {
			resolve(payload);
		});
	});
